import { makeRedirectToSelector } from "@client/content/selectors";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector } from "@client/selectors";
import { type BaseAppState, type EntityRef } from "@client/types";
import { type LinkProps } from "../component";
import { goTo } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { makeLinkTypeSelector } from "./selectors";

export type RedirectLinkProps = EntityRef & Omit<LinkProps, "hasRedirect" | "preventRedirect" | "type">;
const makeRedirectLink = <TProps extends RedirectLinkProps>(target: string, prefix?: string) => {
  const makeMapStateToProps = () => {
    const redirectToSelector = makeRedirectToSelector(target, prefix);
    const linkTypeSelector = makeLinkTypeSelector(target, prefix);

    return (state: BaseAppState, { id, children, source, ...props }: TProps): MapProps => {
      const redirectTo = redirectToSelector(state, { id, source });
      return {
        ...props,
        href: redirectTo?.type === "lightbox" || redirectTo?.url?.startsWith("#") ? redirectTo.url : undefined,
        isNoRedirect: !redirectTo && !props.onClick,
        preventRedirect: state.isEditMode,
        type: linkTypeSelector(state, { id, source })
      };
    };
  };

  const mapDispatchToProps = (dispatch: any, props: TProps): ActionProps => ({
    onClick: (e: React.MouseEvent) =>
      props.onClick ? props.onClick(e) : dispatch(goTo(target, { id: props.id, source: props.source }, prefix))
  });

  return connectCustom(makeMapStateToProps, mapDispatchToProps, { forwardRef: true })(Component);
};
export default makeRedirectLink;

export const RedirectLinkEntity = makeRedirectLink(TargetSelector.Entity);
